const slideTime = 6000; // millisecondi

document.addEventListener('DOMContentLoaded', (e) => {
	let slideshow = document.getElementById('slideshow');

	if (slideshow != null) {
		slick = jQuery('.slideshow').slick({
			dots: true,
			arrows: false,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			swipe: true,
			fade: true,
			autoplay: true,
			autoplaySpeed: slideTime,
			pauseOnHover: false,
			pauseOnFocus: false,
			lazyLoad: 'ondemand'
		});

		document.querySelectorAll('.progress-item').forEach((item) => {
			item.querySelector('.title').addEventListener('click', (evt) => {
				let slideRef = evt.target.closest('.progress-item').id;
				let targetSlide = slideshow.querySelector('[data-ref="#' + slideRef + '"]');
				let slides = [...slideshow.querySelectorAll('.slide')];

				jQuery('.slideshow').slick('slickGoTo', slides.indexOf(targetSlide));
			});
		});
	}
});

jQuery('.slideshow').on('init', function(slick){
	let ctx = document.querySelector('.progress-wrapper');

	if (ctx.querySelector('.progress-item.--active') != null) {
		ctx.querySelector('.progress-item.--active').classList.add('--in-progress');
	}
});

jQuery('.slideshow').on('beforeChange', function(event, slick, currentSlide, nextSlide){
	let nextProgress = slick.$slides[nextSlide].dataset.ref;
	let ctx = document.querySelector('.progress-wrapper');

	if (ctx != null) {
		if (ctx.querySelector('.progress-item.--active') != null) {
			ctx.querySelector('.progress-item.--active').classList.remove('--active', '--in-progress');
		}
		
		document.querySelector(nextProgress).classList.add('--active', '--in-progress');
	}

});
